<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
	<!-- This is the tree node template for leaf nodes -->
	<mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
		<li class="mat-tree-node">
			<!-- use a disabled button to provide padding for tree leaf -->
			<button mat-icon-button disabled></button>

			<mat-checkbox
				*ngIf="!isOnlyOneChoice"
				class="checklist-leaf-node"
				(change)="todoItemSelectionToggle($event.checked, node); sendValues(node.id)"
				[checked]="node.selected"
			>
				{{ node.name }}
			</mat-checkbox>

			<mat-radio-button
				*ngIf="isOnlyOneChoice"
				[checked]="isRadioSelected(node.id)"
				(click)="clickRadio($event, node.id); sendShelfName(node.name)"
				(change)="sendValuesOneCheck(node.id)"
				>{{ node.name }}</mat-radio-button
			>
		</li>
	</mat-tree-node>
	<!-- This is the tree node template for expandable nodes -->
	<mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
		<li>
			<div class="mat-tree-node">
				<button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
					<mat-icon class="mat-icon-rtl-mirror">
						{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
					</mat-icon>
				</button>

				<span *ngIf="canSelectOnlyThirdLevel" class="uniqueSelector" matTreeNodeToggle>{{ node.name }}</span>

				<mat-checkbox
					*ngIf="!isOnlyOneChoice && !canSelectOnlyThirdLevel"
					[checked]="node.selected"
					[indeterminate]="node.indeterminate && !node.selected"
					(change)="todoItemSelectionToggle($event.checked, node); sendValues(node.id)"
				>
					{{ node.name }}
				</mat-checkbox>

				<mat-radio-button
					*ngIf="isOnlyOneChoice && !canSelectOnlyThirdLevel"
					[checked]="isRadioSelected(node.id)"
					(click)="clickRadio($event, node.id); sendShelfName(node.name)"
					(change)="sendValuesOneCheck(node.id)"
					>{{ node.name }}</mat-radio-button
				>
			</div>
			<ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
				<ng-container matTreeNodeOutlet></ng-container>
			</ul>
		</li>
	</mat-nested-tree-node>
</mat-tree>
